import {ColorSchemeType} from 'platform/components';
import {match} from 'ts-pattern';

import {always} from 'ramda';

import i18n from '@dms/i18n';

import {Nullish} from 'shared/web';

export const getTireSetStatus = (state: string | Nullish) => {
  const label = match(state)
    .with('ARCHIVED', always(i18n.t('entity.tireSet.labels.archived')))
    .with('INSTOCK', always(i18n.t('entity.tireSet.labels.inStock')))
    .with('PICKED', always(i18n.t('entity.tireSet.labels.picked')))
    .with('NEW', always(i18n.t('general.labels.new')))
    .otherwise(always(undefined));

  const colorScheme = match<string | Nullish, ColorSchemeType | undefined>(state)
    .with('ARCHIVED', always('neutral'))
    .with('INSTOCK', always('green'))
    .with('PICKED', always('red'))
    .with('NEW', always('blue'))
    .otherwise(always(undefined));

  return {label, colorScheme};
};
